import React, { useRef, useState } from 'react';
import './add-element-modal.styles.scss';
import Modal, { ModalAlert } from '@/components/modal/modal.component';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import { RandomString } from '@/utils/randomString';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { useSelector } from 'react-redux';

const AdminAddElementModal = ({
  show,
  cancel,
  contentType,
  contentContainer,
  alertMessage,
  setAlertMessage
}) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const dataRef = useRef({});

  function saveData(key, value, isData) {
    if (isData) {
      if (dataRef.current.data) {
        let newData = {
          ...dataRef.current.data,
          ...{ [key]: value }
        }
        value = newData;
        key = 'data';
      } else {
        value = { [key]: value };
        key = 'data';
      }
    }
    dataRef.current = {
      ...dataRef.current,
      ...{ [key]: value }
    }
    console.log(dataRef.current);
    setFormData(dataRef.current);
    if (key === 'type') {
      let cat = '';
      switch (value) {
        case 'game':
          cat = 'Template Games';
          break;
        case 'image':
          cat = 'Images';
          break;
        case 'item':
          cat = 'Items';
          break;
        case 'badge':
          cat = 'Badges';
          break;
        case 'collection':
          cat = 'Collections';
          break;
        case 'leaderboard':
          cat = 'Leaderboards';
          break;
        case 'challenge':
          cat = 'Challenges';
          break;
        case 'level':
          cat = 'Levels';
          break;
        case 'secretcode':
          cat = 'Secret Codes';
          break;
        default:
          break;
      }
      saveData('cat', cat)
    }
  }

  async function saveNewContent() {
    let tempData = { ...dataRef.current };
    const now = new Date().getTime();
    if (!formData.data.name || !formData.dir) {
      setAlertMessage('Please fill in all required fields.');
      return;
    }
    if (formData.type === 'game' && !formData.data.gameId && !formData.data.imageUrl) {
      setAlertMessage('Please fill in all required fields for the game type.');
      return;
    }
    setLoading(true);
    const contentId = `${now}_${RandomString(10)}_${formData.type}`
    const dirArr = formData.dir.split(',').map(dir => dir.trim());
    tempData.dir = dirArr;
    let newData = {
      ...tempData.data,
      ...{
        'type': formData.type,
        'id': contentId,
      }
    }
    tempData = {
      ...tempData,
      ...{
        'id': contentId,
        'status': 'active',
        'ts': now,
        'data': newData
      }
    }
    console.log(tempData);
    const res = await UseCloudFunction(
      'addContentToPackage',
      {
        'appId': userProfile.appId,
        'contentData': tempData,
        'packageId': contentContainer,
      }
    )
    console.log(res);
    if (res.error) {
      setLoading(false);
      setAlertMessage(`Something went wrong. Please try again later. (Error: ${res.error})`);
      return;
    }
    setAlertMessage('Content added successfully!');
    cancelContent();
  }

  function cancelContent() {
    setLoading(false);
    dataRef.current = {};
    setFormData(dataRef.current);
    cancel();
  }

  return (
    <div className='admin-add-element-modal'>
      <Modal
        show={show}
        cancel={cancel}
        text={`Add content to "${contentContainer}"`}
        closeButton={true} >
        <div className='admin-add-element-modal__content'>
          <div className='field'>
            <label>Choose a content type</label>
            <select
              value={formData.type ?? ''}
              onChange={(e) => saveData('type', e.target.value)}>
              <option value=''>Select a content type</option>
              {/* <option value='game'>Template Game</option> */}
              <option value='image'>Image</option>
              <option value='item'>Item</option>
              <option value='badge'>Badge</option>
              <option value='collection'>Collection</option>
              <option value='leaderboard'>Leaderboard</option>
              <option value='challenge'>Challenge</option>
              <option value='level'>Level</option>
              <option value='secretcode'>Secret Code</option>
            </select>
          </div>
          <div className="g-space-0-5"></div>
          {
            (formData?.type) &&
            <div className='form-div'>
              <div className='field'>
                <label>Name</label>
                <input
                  type='text'
                  value={formData?.data?.name ?? ''}
                  onChange={(e) => saveData('name', e.target.value, true)} />
              </div>
              <div className='field'>
                <label>Directory List</label>
                <div className='meta'>Separate by commas</div>
                <input
                  type='text'
                  value={formData.dir && typeof formData.dir === 'object' ? formData.dir.join(', ') : formData.dir}
                  onChange={(e) => saveData('dir', e.target.value)} />
              </div>
              {
                (formData?.type !== 'image') &&
                <>
                  <div className='field'>
                    <label>Element ID</label>
                    <input
                      type='text'
                      value={formData?.data?.elementId ?? ''}
                      onChange={(e) => saveData('elementId', e.target.value, true)} />
                  </div>
                </>
              }
              {
                (formData?.type === 'image') &&
                <>
                  <div className='field'>
                    <label>Image URL</label>
                    <input
                      type='text'
                      value={formData?.data?.url ?? ''}
                      onChange={(e) => saveData('url', e.target.value, true)} />
                  </div>
                  <div className='field-checkbox'>
                    <input
                      type='checkbox'
                      id='isCropped'
                      checked={ formData?.cropped ? true : false }
                      onChange={(e) => saveData('cropped', e.target.checked)} />
                    <label htmlFor='isCropped'>Cropped Square Image</label>
                  </div>
                </>
              }
              <div className="g-space-1"></div>
              {
                (loading)
                  ?
                  <div className='buttons'>
                    <div
                      className='g-button' >
                      Cancel
                    </div>
                    <div
                      className='g-button' >
                      <ThreeDotsLoader />
                    </div>
                  </div>
                  :
                  <div className='buttons'>
                    <div
                      className='g-button'
                      onClick={() => cancelContent()}>
                      Cancel
                    </div>
                    <div
                      className='g-button primary'
                      onClick={saveNewContent}>
                      Save
                    </div>
                  </div>
              }
            </div>
          }
        </div>
      </Modal>
    </div>
  )
}

export default AdminAddElementModal